module.exports = __webpack_public_path__ + "static/media/icons_down-black.8124e893.svg";